var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { attrs: { id: "brand-animation" } }, [
    _c("div", { staticClass: "row justify-content-between" }, [
      _c("div", { staticClass: "col-12 col-lg-3" }, [
        _c("h2", {
          staticClass: "mt-lg-5",
          domProps: { innerHTML: _vm._s(_vm.brandAnimation.title) },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-lg-9" }, [
        _c(
          "ul",
          { staticClass: "advantage-list row ps-0 ps-lg-3" },
          [
            _vm._l(
              _vm.brandAnimation.brandAdvantages,
              function (advantage, index) {
                return _c(
                  "li",
                  {
                    key: "adv-" + index,
                    staticClass: "col-12 col-md-6 mb-1 mb-md-2 px-1",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "advantage-item h-100 bg-white p-2" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "mb-1 d-flex justify-content-center d-webview-none",
                          },
                          [
                            _c("span", {
                              staticClass: "advantage-icon text-primary",
                              class: [advantage.icon],
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "mt-md-0 mb-md-2" }, [
                          _c("h4", {
                            staticClass: "py-0",
                            domProps: { innerHTML: _vm._s(advantage.title) },
                          }),
                          _vm._v(" "),
                          _c("p", {
                            staticClass: "text-gray3 mb-0 py-0",
                            domProps: { innerHTML: _vm._s(advantage.text) },
                          }),
                        ]),
                      ]
                    ),
                  ]
                )
              }
            ),
            _vm._v(" "),
            _c("li", { staticClass: "col-12 px-1 mb-2" }, [
              _c(
                "div",
                { staticClass: "d-lg-none advantage-item h-100 bg-white p-2" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "mb-1 d-flex justify-content-center d-webview-none",
                    },
                    [
                      _c("img", {
                        staticClass: "advantages-picto d-lg-flex",
                        attrs: {
                          loading: "lazy",
                          alt: "",
                          src: _vm.brandAnimation.reloadMarquePicto,
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-md-0 mb-md-2" }, [
                    _c("h4", {
                      staticClass: "py-0",
                      domProps: {
                        innerHTML: _vm._s(_vm.brandAnimation.reloadMarqueTitle),
                      },
                    }),
                    _vm._v(" "),
                    _c("p", {
                      staticClass: "text-gray3 mb-0 py-0",
                      domProps: {
                        innerHTML: _vm._s(_vm.brandAnimation.reloadMarqueText),
                      },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-none d-lg-block bg-white advantage-item" },
                [
                  _c("div", { staticClass: "ps-5" }, [
                    _c("img", {
                      staticClass: "advantages-image d-lg-flex",
                      attrs: {
                        loading: "lazy",
                        alt: "",
                        src: _vm.brandAnimation.image,
                      },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-none d-lg-block advantages-reload position-absolute bg-white",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "mb-1 d-flex justify-content-start d-webview-none",
                    },
                    [
                      _c("img", {
                        staticClass: "advantages-picto d-lg-flex",
                        attrs: {
                          loading: "lazy",
                          alt: "",
                          src: _vm.brandAnimation.reloadMarquePicto,
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-md-0 mb-md-2" }, [
                    _c("h4", {
                      staticClass: "py-0",
                      domProps: {
                        innerHTML: _vm._s(_vm.brandAnimation.reloadMarqueTitle),
                      },
                    }),
                    _vm._v(" "),
                    _c("p", {
                      staticClass: "text-gray3 mb-0 py-0",
                      domProps: {
                        innerHTML: _vm._s(_vm.brandAnimation.reloadMarqueText),
                      },
                    }),
                  ]),
                ]
              ),
            ]),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }